import { render, staticRenderFns } from "./RevokeConsents.vue?vue&type=template&id=4d9e5e2b"
import script from "./RevokeConsents.vue?vue&type=script&lang=js"
export * from "./RevokeConsents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports